import { h } from "preact";
import { observer } from "mobx-preact";
import "./index.less";


const prefix = "register-success";

const RegisterSuccess = ({ store }) => {
  store.use();
  return (<div className={`${prefix}-registerSuccess`}>
    <div className={`${prefix}-success`}/>
  </div>);

};

export default observer(RegisterSuccess);
